import React, { useEffect, useRef } from 'react';
import ErrorBoundary from 'sensortower-components/src/base-components/ErrorBoundary';

import hljs from 'highlight.js';
import 'highlight.js/styles/github.css';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import { sidekick } from '../../utils/sidekick';

export interface CodeSnippetProps {
  __typename?: string;
  sidekickLookup?: any;
  description?: string;
  code: string;
  language?: string;
}

const Root = styled(Box)({
  textAlign: 'left'
}) as typeof Box;

const Pre = styled('pre')({
  margin: 0
});

export const CodeSnippet = ({ description: _description, code, language, sidekickLookup }: CodeSnippetProps) => {
  const codeRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    let highlightedCode;

    try {
      highlightedCode = language
        ? hljs.highlight(code, { language: language, ignoreIllegals: true })
        : hljs.highlightAuto(code);
    } catch (error) {
      highlightedCode = hljs.highlight(code, { language: 'plaintext' });
    }

    if (codeRef.current) {
      codeRef.current.innerHTML = highlightedCode.value;
    }
  }, [code, language]);

  return (
    <ErrorBoundary>
      <Root {...sidekick(sidekickLookup)} data-testid="CodeSnippet">
        <Pre className="hljs">
          <code ref={codeRef} data-testid="CodeSnippet-code"></code>
        </Pre>
      </Root>
    </ErrorBoundary>
  );
};

export default CodeSnippet;
